import { useAppSelector } from 'app/hooks';
import { hasEntitlementAccess } from 'utils';
import {
  selectEntitlements,
  selectIsUserAgent,
  selectUserFeatures,
} from 'services/session/sessionSelectors';
import { rawEntitlementsIncludeNewsArticles } from 'services/session/utils';
import {
  SERVICE_ENTITLEMENTS_MAPPING,
  SERVICES,
} from 'utils/service-entitlements-config';
import type { ServicesType } from 'utils/globalTypes';

function useIsFeatureAvailable(
  service: ServicesType | string[],
  agentCheckRequired = true,
) {
  const userFeatures = useAppSelector(selectUserFeatures);
  const isAgent = useAppSelector(selectIsUserAgent);
  const rawEntitlements = useAppSelector(selectEntitlements);

  const entitlements = Array.isArray(service)
    ? service
    : SERVICE_ENTITLEMENTS_MAPPING[service as ServicesType];

  const hasMappedAccess = hasEntitlementAccess({
    userFeatures,
    entitlements,
    isAgent,
    agentCheckRequired,
  });

  if (hasMappedAccess) return true;

  if (service === SERVICES.insightsAndTips) {
    return rawEntitlementsIncludeNewsArticles(rawEntitlements);
  }

  return false;
}

export default useIsFeatureAvailable;
